<template>
  <div class="today">
    <div class="set-routes-container">
      <div class="card table-view">
        <DataTable
          :value="setRoutes"
          :paginator="true"
          class="p-datatable-customers"
          :rows="10"
          v-model:selection="selectedProducts3"
          dataKey="id"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 20, 50]"
          v-model:filters="filters2"
          filterDisplay="row"
          :loading="LoadingData"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          :globalFilterFields="[
            'source',
            'destination',
            'date',
            'busplatenumber',
          ]"
        >
          <template #header>
            <div class="p-d-flex p-jc-end">
              <span class="p-input-icon-left ">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters2['global'].value"
                  placeholder="Keyword Search"
                />
              </span>
            </div>
          </template>
          <template #empty>
            There are no today schedules
          </template>
          <template #loading>
            Loading schedules data. Please wait.
          </template>
          <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
          <Column
            field="source"
            header="Source"
            sortable="true"
            style="min-width:12rem"
          >
            <template #body="{data}">
              {{ data.source }}
            </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['source'].value"
                class="p-column-filter"
                :placeholder="`Search by source - `"
              />
            </template>
          </Column>

          <Column
            field="destination"
            header="Destination"
            sortable="true"
            style="min-width:12rem"
          >
            <template #body="{data}">
              {{ data.destination }}
            </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['destination'].value"
                class="p-column-filter"
                :placeholder="`Search by destination - `"
              />
            </template>
          </Column>

          <Column
            field="date"
            header="Time of departure"
            sortable="true"
            style="min-width:12rem"
          >
            <template #body="{data}">
              {{ data.starttime }}
            </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['date'].value"
                class="p-column-filter"
                :placeholder="`Search by time - `"
              />
            </template>
          </Column>
          <Column
            field="busplatenumber"
            header="Bus plate number"
            sortable="true"
            style="min-width:12rem"
          >
            <template #body="{data}">
              {{ data.busplatenumber }}
            </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['busplatenumber'].value"
                class="p-column-filter"
                :placeholder="`Search by bus - `"
              />
            </template>
          </Column>
        </DataTable>
      </div>
      <!-- table card for mobile -->

      <div class="card mobile_cards_instead_of_table ">
        <DataView
          :value="setRoutes"
          :paginator="true"
          :rows="9"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        >
          <template #empty>
            There are no today schedules.
          </template>
          <template #list="slotProps">
            <div class="p-col-12">
              <div class="col-sm-12 col-12 single-card">
                <div class="sub-content d-flex">
                  <p class="title">Source:</p>
                  <p class="content pl-2">
                    {{ slotProps.data.source }}
                  </p>
                </div>
                <div class="sub-content d-flex">
                  <p class="title">Destination:</p>
                  <p class="content pl-2">{{ slotProps.data.destination }}</p>
                </div>
                <div class="sub-content d-flex">
                  <p class="title">Depart time:</p>
                  <p class="content pl-2">
                    {{ slotProps.data.starttime }}
                  </p>
                </div>
                <div class="sub-content d-flex">
                  <p class="title">Bus:</p>
                  <p class="content pl-2">
                    {{ slotProps.data.busplatenumber }}
                  </p>
                </div>
              </div>
            </div>
          </template>
        </DataView>
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import axios from "axios";
let token = localStorage.getItem("jwt");
const headers = { Authorization: `Bearer ${token}` };
export default {
  data() {
    return {
      selectedProducts3: null,
      filters2: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        busplatenumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
        source: { value: null, matchMode: FilterMatchMode.CONTAINS },
        destination: { value: null, matchMode: FilterMatchMode.CONTAINS },
        date: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      setRoutes: [],
    };
  },
  mounted() {
    this.getSchedules();
  },
  computed: {
    formattedDate() {
      return this.formatDate(this.date);
    },
  },
  methods: {
    getSchedules() {
        axios
          .get(
            "https://bookinga.herokuapp.com/api/v1/busSchedule/schedules/today",
            { headers }
          )
          .then((res) => {
            if (res.data.message != "No schedules for today") {
              this.setRoutes = res.data.message;
              this.LoadingData = false;
            } else {
              this.LoadingData = false;
            }
          })
          .catch((res) => {
            this.LoadingData = false;
          });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../companyAdmin/tables_mobile.scss";
</style>
